import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { init } from "./init";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const params = new URLSearchParams(window.location.search);
const isPreview = params.get("preview") === "1";

const hasTelegramContext = () => {
  const telegram = (window as any).Telegram?.WebApp;
  const userAgent = navigator.userAgent || "";
  return Boolean(
    telegram?.initData ||
    (window as any).__SAYMON_TELEGRAM_CONTEXT__ ||
    /Telegram/i.test(userAgent) ||
    params.has("tgWebAppData") ||
    params.has("tgWebAppPlatform") ||
    params.has("tgWebAppVersion") ||
    params.has("tgWebAppFullscreen") ||
    params.has("user_id") ||
    sessionStorage.getItem("saymon.telegram.session") === "1"
  );
};

const telegramOnlyFallback = (
  <div style={{
    minHeight: "100vh",
    display: "grid",
    placeItems: "center",
    padding: 24,
    boxSizing: "border-box",
    background: "#101118",
    color: "#fff",
    fontFamily: "Arial, sans-serif",
    textAlign: "center",
  }}>
    {"\u041e\u0442\u043a\u0440\u043e\u0439\u0442\u0435 \u043f\u0440\u0438\u043b\u043e\u0436\u0435\u043d\u0438\u0435 \u0438\u0437 Telegram"}
  </div>
);

function TelegramOnlyGate({ children }: { children: React.ReactNode }) {
  const [status, setStatus] = React.useState<"allowed" | "blocked">(
    hasTelegramContext() ? "allowed" : "allowed"
  );

  React.useEffect(() => {
    if (isPreview || hasTelegramContext()) {
      if (hasTelegramContext()) sessionStorage.setItem("saymon.telegram.session", "1");
      return;
    }

    const startedAt = Date.now();
    const timer = window.setTimeout(() => {
      if (!hasTelegramContext() && Date.now() - startedAt >= 5000) {
        setStatus("blocked");
      }
    }, 5000);

    return () => window.clearTimeout(timer);
  }, []);

  if (status === "blocked") return telegramOnlyFallback;
  return <>{children}</>;
}

try {
  init();
} catch (e) {
  // Keep the app usable while Telegram restores its native bridge after resume.
  console.error("Telegram bridge initialization failed", e);
}

root.render(
  isPreview ? (
    <BrowserRouter><App /></BrowserRouter>
  ) : (
    <TelegramOnlyGate>
      <BrowserRouter><App /></BrowserRouter>
    </TelegramOnlyGate>
  )
);
